import { HomeOutlined } from '@ant-design/icons';
import { Card, Collapse, Empty } from 'antd';
import { Box, DataRow, FormGroup } from 'components';
import { devicesSelector } from 'features/merchants/redux';
import { FirebaseCollectionsType } from 'firebaseAPI';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useFirestoreConnect } from 'react-redux-firebase';
import { styled } from 'theme';
import type { Firebase } from 'types/firebase';

const StyledEmpty = styled(Empty)`
  && {
    margin: 0;
  }
`;

export type MerchantDeviceDetailsProps = {
  merchantId: string;
  accountId: string;
};

const MerchantDeviceDetails: React.FC<MerchantDeviceDetailsProps> = (props) => {
  const devices = useSelector(devicesSelector);
  useFirestoreConnect({
    collection: FirebaseCollectionsType.DEVICES,
    storeAs: FirebaseCollectionsType.DEVICES,
    doc: props?.accountId,
    subcollections: [
      {
        collection: FirebaseCollectionsType.DEVICE_LIST,
        storeAs: FirebaseCollectionsType.DEVICES,
      },
    ],
  });

  if (!devices) {
    return null;
  }

  return (
    <Box>
      <FormGroup icon={<HomeOutlined />} title={`Devices`}>
        {Object.values(devices)?.length > 0 ? (
          <Collapse>
            {Object.values(devices)?.map((device) => (
              <Collapse.Panel
                key={device?.id}
                header={`${
                  device?.uid
                }: (${device?.deviceBrand?.toUpperCase()} ${
                  device?.deviceName
                })`}
              >
                {device?.terminalEventHistory?.map((entry) => {
                  return (
                    <Box key={entry?.created} mb="12px">
                      <Card style={{ borderRadius: '8px' }}>
                        <Box>
                          <DataRow
                            label="Date"
                            value={
                              moment(entry?.date).format('DD.MM.YY HH.mm') ??
                              'N/A'
                            }
                          />
                          <DataRow label="Tid" value={entry?.tid ?? 'N/A'} />
                          <DataRow
                            label="Status"
                            value={entry?.status ?? entry?.type ?? 'N/A'}
                          />
                          <DataRow
                            label="App ID"
                            value={entry?.appId ?? 'N/A'}
                          />
                          {entry?.type === 'FAILED' && (
                            <DataRow
                              label="Error"
                              value={`${entry?.event?.errorCode} / ${entry?.event?.internalErrorCode} - ${entry?.event?.errorMessage}`}
                            />
                          )}
                        </Box>
                      </Card>
                    </Box>
                  );
                })}
              </Collapse.Panel>
            ))}
          </Collapse>
        ) : (
          <StyledEmpty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No terminals"
          />
        )}
      </FormGroup>
    </Box>
  );
};

export { MerchantDeviceDetails };
